import { PostHogPageview } from './PostHogPageview';
import { useGoogleAnalytics } from '../hooks/useGoogleAnalytics';

export function Analytics() {
  useGoogleAnalytics();
  
  return <PostHogPageview />;
} 